import SMP_CONFIG from '@/util/smp_config';

/**
 * module that contains some random helper functions
 * @module utils */

/**
 * get country config
 * @returns {Object}
 */
const getCountryConfig = () => {
  return SMP_CONFIG.countryConfig;
};

/**
 * get current language from smp_config
 * @returns {String}
 */
const getCurrentLanguage = () => {
  // If Workshop set default language for webkit then use it
  if (SMP_CONFIG.applicationConfig && SMP_CONFIG.applicationConfig.languageCode) {
    return SMP_CONFIG.applicationConfig.languageCode;
  }

  // Fallback country language code
  return SMP_CONFIG.countryConfig.defaultLanguageCode;
};

/**
 * get currency symbol
 * @returns {String}
 */
const getCurrencySymbol = () => {
  if (SMP_CONFIG && SMP_CONFIG.countryConfig &&
    SMP_CONFIG.countryConfig.currency &&
    SMP_CONFIG.countryConfig.currency.symbol) {
    return SMP_CONFIG.countryConfig.currency.symbol;
  } else if (SMP_CONFIG && SMP_CONFIG.countryConfig &&
    SMP_CONFIG.countryConfig.countryCode &&
    SMP_CONFIG.countryConfig.currency) {
    // if currency symbol is missing in context country config, return it based on country-language
    return Number().toLocaleString(`${SMP_CONFIG.countryConfig.countryCode}-${getCurrentLanguage()}`,
      { style: 'currency', currency: SMP_CONFIG.countryConfig.currency.code || 'EUR' }).slice(-1);
  }
  return '€';
};

/**
 * get decimal separator from a number
 * @param num number
 * @returns {String}
 */
const getDecimalSeparator = num => {
  return Math.max(num.lastIndexOf(','), num.lastIndexOf('.')) === num.lastIndexOf(',') ? ',' : '.';
};

/**
 * clone an object
 * @param {Object} object to clone
 * @returns {Object}
 */
const cloneObject = object => {
  return JSON.parse(JSON.stringify(object));
};

export default {
  getCountryConfig,
  getCurrencySymbol,
  getCurrentLanguage,
  getDecimalSeparator,
  cloneObject
}
